import { Component, signal } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrls: ['./app.scss']
})
export class App {
  protected readonly title = signal('training-course');
   constructor(private router: Router) {}

  ngOnInit() {
    const params = new URLSearchParams(window.location.search);
    
    const encryptedToken = params.get("token");

    if (encryptedToken) {

  const secretKey = "k@a!b@ood123le1234m!!!!!uddy9876shoe@#&s";

  // Decode URL
  const decoded = decodeURIComponent(encryptedToken);

  // Decrypt token
  const bytes = CryptoJS.AES.decrypt(decoded, secretKey);

  const originalToken = bytes.toString(CryptoJS.enc.Utf8);

  // Parse once
  const parsedToken = JSON.parse(originalToken);

  console.log("Decrypted token:", parsedToken);

  // Store hostUrl
  const hostUrl = parsedToken?.schoolDetails?.hostUrl;
  if (hostUrl) {
    localStorage.setItem('hostUrl', hostUrl);
  }

  // Store ONLY token string
  localStorage.setItem("token", parsedToken.token);

  // Store FULL user object
  localStorage.setItem('user', JSON.stringify(parsedToken));
}

  

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (typeof window !== 'undefined') {
  window.scrollTo(0, 0);
}
    });
  }
}
